import React from "react";
import "./Muhammadabad.css"; // Reuse your CSS
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Ghosi = () => {
  return (
    <div className="dp-page">

      <Helmet>
        <title>Popular Aluminium Works in Ghoshi, Mau | Trusted Fabricators</title>
        <meta
          name="description"
          content="Find reliable aluminium works in Ghoshi, Mau, Uttar Pradesh. Local fabricators provide sliding windows, aluminium doors, partitions, kitchen cupboards, and custom aluminium solutions for homes and offices."
        />
        <meta
          name="keywords"
          content="Aluminium Works Ghoshi UP, Aluminium Fabricators, Sliding Windows, Aluminium Doors, Partitions, Kitchen Cupboards, Custom Aluminium Work, Window Installation"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Popular Aluminium Works in Ghoshi, Mau" />
        <meta
          property="og:description"
          content="Trusted aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, and custom aluminium solutions for homes and offices in Ghoshi, Mau, Uttar Pradesh."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Popular Aluminium Works in Ghoshi, Mau" />
        <meta
          name="twitter:description"
          content="Skilled aluminium fabricators providing sliding windows, doors, partitions, kitchen cupboards, and custom aluminium solutions in Ghoshi, Mau, Uttar Pradesh."
        />
      </Helmet>

      {/* HERO SECTION */}
      <section className="dp-section">
        <div className="dp-container dp-split">
          <div>
            <h1>Popular Aluminium Works in Ghoshi, Mau, Uttar Pradesh</h1>
            <p>
              Ghoshi, Mau has become a trusted destination for high-quality aluminium works. With growing residential construction, office setups, and commercial renovations, the demand for skilled aluminium fabricators and glass specialists has increased rapidly. Local dealers now provide a wide range of services including sliding windows, aluminium doors, partitions, kitchen cupboards, and custom fabrication.
            </p>
          </div>
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765908421/WhatsApp_Image_2025-12-16_at_10.06.41_AM_mdtfzb.jpg"
            alt="aluminium-works-ghosi"
          />
        </div>
      </section>

      {/* WHY ALUMINIUM WORKS */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Why Aluminium Works Are Popular in Ghoshi, Mau</h2>
          <p>
            Aluminium works in Ghoshi, Mau are preferred for their strength, modern design, and low maintenance. Local fabricators specialize in sliding windows, aluminium doors, partitions, kitchen cupboards, and glass installations. Their expertise ensures precise fitting, durability, and stylish finishing for homes, offices, and commercial spaces.
          </p>
          <p>
            Customers can also choose options like powder-coated frames, safety grills, and toughened glass, making aluminium works suitable for all building types.
          </p>
        </div>
      </section>

      {/* TRUSTED FABRICATORS */}
      <section className="dp-section dp-box-layout">
        <img
          src="https://res.cloudinary.com/di82vlbpn/image/upload/v1765616717/WhatsApp_Image_2025-12-11_at_10.52.30_PM_1_fynu60.jpg"
          alt="trusted-fabricators-ghosi"
        />
        <div className="dp-box">
          <h2>Trusted Aluminium Fabricators in Ghoshi</h2>
          <p>
            Many customers in Ghoshi prefer local aluminium fabricators because they provide personalized service, quick installation, and reliable after-sales support. Experienced fabricators manage everything from measurement to final installation, guiding clients on aluminium grade, glass thickness, and hardware for optimal performance.
          </p>
          <p>
            Fabricators often serve nearby areas as well, ensuring transparent pricing, convenient scheduling, and professional service for every project.
          </p>
        </div>
      </section>

      {/* SLIDING WINDOWS & DOORS */}
      <section className="cp-page">
        <section className="cp-scroll">
          <div className="cp-scroll-text">
            <h2>Aluminium Sliding Windows and Doors</h2>
            <p>
              Sliding aluminium windows are widely used in Ghoshi due to their space-saving design, smooth operation, and modern look. They are ideal for bedrooms, kitchens, offices, and balconies. Aluminium sliding doors with glass panels enhance shopfronts and commercial interiors, combining style with strength and security.
            </p>
          </div>
          <div className="cp-scroll-img"></div>
        </section>
      </section>

      {/* CUSTOM FABRICATION */}
      <section className="dp-section">
        <div className="dp-container">
          <h2>Custom Aluminium Fabrication and Glass Work in Ghoshi</h2>
          <p>
            Fabricators in Ghoshi provide customized solutions for aluminium partitions, window grills, office cabins, kitchen cupboards, and glass panels. Custom work ensures proper fitting, elegant finishing, and long-term durability. Repair and replacement services for locks, sliding systems, and glass are also available.
          </p>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section className="dp-section">
        <div className="dp-container dp-box-layout">
          <img
            src="https://res.cloudinary.com/di82vlbpn/image/upload/v1766165233/Screenshot_2025-12-19_225650_raucxl.png"
            alt="service-areas-ghosi"
          />
          <div className="dp-box">
            <h2>Serving Ghoshi, Mau and Nearby Areas</h2>
            <p>
              Aluminium works in Ghoshi are available across nearby villages, towns, and markets in Mau, making it easy to schedule measurements, site visits, and installations. Local service coverage helps homeowners, shop owners, and builders complete projects efficiently and on budget.
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="aluminium-content">
        <div className="container">
          <h1>Choosing Aluminium Works in Ghoshi, Mau</h1>
          <p>
            Ghoshi has become a trusted market for aluminium fabrication, glass works, and UPVC solutions. Local dealers provide sliding windows, aluminium doors, partitions, kitchen cupboards, and custom glass work for residential, commercial, and office spaces.
          </p>

          <h2>Top Aluminium Fabricators in Ghoshi</h2>
          <p>
            Leading fabricators in Ghoshi specialize in aluminium windows, doors, partitions, and decorative grills. Their expertise ensures quality workmanship and timely installation.
          </p>

          <h2>Top Aluminium Door Dealers in Ghoshi</h2>
          <p>
            Aluminium doors in Ghoshi are highly preferred for durability, security, and modern aesthetics. Trusted dealers offer a variety of designs suitable for homes, shops, and offices.
          </p>

          <h2>Kitchen Cupboard Aluminium Works in Ghoshi</h2>
          <p>
            Aluminium kitchen cupboards are popular for easy cleaning, durability, and modern designs. Fabricators provide customized cupboards that perfectly fit your home or office layout.
          </p>

          <h2>Glass and Partition Works in Ghoshi</h2>
          <p>
            Local dealers also specialize in toughened glass panels, partitions, and ACP sheets. These services enhance interior aesthetics, provide safety, and add a contemporary look to residential and commercial spaces.
          </p>

          <h2>Top Hardware Dealers in Ghoshi</h2>
          <p>
            Hardware dealers supply locks, handles, fittings, and other accessories for aluminium, UPVC, and glass works, ensuring smooth operation and long-lasting performance.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="dp-cta">
        <h2>Book Your Aluminium Work Today in Ghoshi, Mau</h2>
        <Link to="/contact"><button>Contact Us</button></Link>
      </section>

    </div>
  );
};

export default Ghosi;
